import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {ToastModule} from 'primeng/toast';
import {ContainerUserCustomerComponent} from './container-user-customer/container-user-customer.component';
import {BadgeModule} from "primeng/badge";
import {CustomerModule} from "@iw-shop/customer/customer.module";
import {UserModule} from "@iw-shop/user/user.module";
import {NewsModule} from "@iw-shop/news/news.module";
import {CoreModule} from "@iw-shop/core/core.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {LayoutShopComponent} from "@_basic/layout/shop/layout-shop.component";
import { LoginRequiredComponent } from './login-required/login-required.component';
import {DeliveryTourModule} from "@iw-shop/delivery-tour/delivery-tour.module";
import { PopoverModule } from 'primeng/popover';
import {ArticleModule} from "@iw-shop/article/article.module";
import {DynamicPageModule} from "@iw-shop/dynamic-page/dynamic-page.module";
import {ContactModule} from "@iw-shop/contact/contact.module";
import {Tooltip} from "primeng/tooltip";

@NgModule({
  declarations: [
    LayoutShopComponent,
    ContainerUserCustomerComponent,
    LoginRequiredComponent
  ],
    exports: [
        LayoutShopComponent,
        ContainerUserCustomerComponent,
        LoginRequiredComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        ToastModule,
        BadgeModule,
        CustomerModule,
        UserModule,
        NewsModule,
        CoreModule,
        FontAwesomeModule,
        DeliveryTourModule,
        PopoverModule,
        ArticleModule,
        DynamicPageModule,
        ContactModule,
        Tooltip
    ]
})
export class LayoutModule {
}
